import { setCcpaStringCookie, getCcpaStringFromCookie } from './cookieutils';

/**
 * The usprivacy string as the format: ”vnol” where
 *  v = version
 *  n = Notice Given
 *  o = OptedOut
 *  l = lspact (Limited Service Provider Agreement Covered Transaction)
 * Example: “1YYY” Version 1, Notice given, Opted out, LSAPCT in place.
 * Default is null.
 */
//TODO: replace this with usprivacy-string

export enum CcpaCookieValues {
  ACCEPTED_ALL = '1YYY',
  REJECTED_ALL = '1NNN',
}

export function accept() {
  setCcpaStringCookie(CcpaCookieValues.ACCEPTED_ALL);
}

export function reject() {
  setCcpaStringCookie(CcpaCookieValues.REJECTED_ALL);
}

export function getCcpaCookieState() {
  const ccpaString = getCcpaStringFromCookie();

  return ccpaString === CcpaCookieValues.ACCEPTED_ALL;
}
